export const fr = {
  common: {
    loading: 'Chargement…',
    error: 'Erreur',
    success: 'Succès',
    info: 'Information',
    cancel: 'Annuler',
    save: 'Enregistrer',
    saving: 'En cours...',
    edit: 'Modifier',
    delete: 'Supprimer',
    close: 'Fermer',
    backToHome: "Retour à l'accueil",
    backToDashboard: 'Retour au tableau de bord',
    genericError: 'Une erreur est survenue. Réessayez.',
    networkError: "Impossible de contacter le serveur. Vérifiez qu'il est démarré, puis réessayez.",
    hidden: 'Masqué',
  },
  labels: {
    difficulty: {
      1: 'Niveau 1 — Syntaxe',
      2: 'Niveau 2 — Bug évident',
      3: 'Niveau 3 — Anomalie visible',
      4: 'Niveau 4 — Anomalies cachées',
      5: 'Niveau 5 — Expert',
    },
    category: {
      security_owasp: 'Sécurité (OWASP)',
      performance: 'Performance',
      architecture: 'Robustesse / Architecture',
      race_condition: 'Concurrence',
      business_logic: 'Logique métier',
    },
    severity: {
      critical: 'Critique',
      major: 'Majeure',
      minor: 'Mineure',
    },
  },
  errors: {
    invalidPassword: 'Le mot de passe actuel est incorrect.',
    invalidEmail: "L'adresse e-mail n'est pas valide.",
    emailTaken: 'Un compte existe déjà avec cette adresse e-mail.',
    passwordTooShort: 'Le mot de passe doit contenir au moins {min} caractères.',
    passwordTooLong: 'Le mot de passe est trop long ({max} caractères maximum).',
    passwordMissing: 'Le mot de passe doit contenir au moins {list}.',
    passwordPolicy: '{min} caractères minimum, avec au moins une minuscule, une majuscule, un chiffre et un symbole.',
    ruleLower: 'une minuscule',
    ruleUpper: 'une majuscule',
    ruleDigit: 'un chiffre',
    ruleSymbol: 'un symbole',
    listAnd: 'et',
    signUpFailed: "L'inscription a échoué. Vérifiez les informations saisies.",
    invalidToken: 'Le lien de réinitialisation est invalide ou a expiré.',
    userNotFound: 'Utilisateur introuvable.',
    passwordSameAsCurrent: 'Le nouveau mot de passe doit être différent de l’ancien.',
    generic: 'Une erreur est survenue. Vérifiez les informations saisies.',
    server: 'Le serveur a rencontré une erreur. Réessayez dans un instant.',
  },
  apiErrors: {
    unauthorized: 'Votre session a expiré. Reconnectez-vous.',
    missingParams: 'Choisissez un langage, une difficulté et une catégorie, ou le mode Mystère.',
    attemptNotFound: 'Challenge introuvable.',
    alreadySubmitted: 'Cette revue a déjà été soumise.',
    invalidComment: 'Une remarque vise une ligne absente du diff ou est vide.',
    rateLimited: 'Trop de challenges lancés récemment. Réessayez dans un moment.',
  },
  header: {
    brandAria: 'Accueil Code How?',
    brandBadge: 'IA Review',
    navAria: 'Navigation principale',
    navDemo: 'Démo de Code',
    navLanguages: 'Langages',
    navMethod: 'Méthode',
    navProgress: 'Progression',
    home: 'Accueil',
    dashboard: 'Tableau de bord',
    accountSettings: 'Paramètres du compte',
    accountSettingsFor: 'Paramètres du compte de {name}',
    logout: 'Se déconnecter',
    login: 'Se connecter',
    register: 'S’inscrire',
    switchLangAria: 'Passer en anglais',
    switchLangTitle: 'Switch to English',
  },
  footer: {
    brandDesc:
      "La plateforme d'entraînement à la relecture critique de code, à la sécurité applicative (OWASP) et aux bonnes pratiques de Pull Request.",
    platform: 'Plateforme',
    codeDemo: 'Démo de Code',
    supportedLanguages: 'Langages supportés',
    methodWorkflow: 'Méthode & Workflow',
    dashboard: 'Tableau de bord',
    accountAccess: 'Compte & Accès',
    logout: 'Se déconnecter',
    login: 'Se connecter',
    register: "S'inscrire",
    qualityNorms: 'Qualité & Normes',
    wcagNote:
      'Interface accessible conforme WCAG AA avec contrastes vérifiés et navigation clavier complète.',
    copyright: '© 2026 Code How? • Projet Technologies Web — Tous droits réservés.',
  },
  auth: {
    loginTitle: 'Connectez-vous à votre compte',
    registerTitle: 'Créez un nouveau compte',
    emailLabel: 'Adresse e-mail',
    emailPlaceholder: 'vous@exemple.fr',
    emailRequired: "L'adresse e-mail est requise.",
    passwordLabel: 'Mot de passe',
    passwordConfirmLabel: 'Confirmez le mot de passe',
    nameLabel: 'Pseudonyme',
    namePlaceholder: 'Ex : thomas',
    nameHint: 'Visible par les autres utilisateurs.',
    nameRequired: 'Le pseudonyme est requis.',
    passwordsDoNotMatch: 'Les deux mots de passe ne correspondent pas.',
    invalidCredentials: 'Adresse e-mail ou mot de passe incorrect.',
    pleaseWait: 'Patientez…',
    signInBtn: 'Se connecter',
    signUpBtn: "S'inscrire",
    noAccount: 'Pas encore de compte ?',
    hasAccount: 'Déjà un compte ?',
    forgotPasswordLink: 'Mot de passe oublié ?',
    forgotPasswordTitle: 'Mot de passe oublié',
    forgotPasswordSubtitle: 'Saisissez votre adresse e-mail pour réinitialiser votre mot de passe.',
    forgotPasswordSubmitBtn: 'Envoyer les instructions',
    forgotPasswordSent: 'Si un compte existe avec cette adresse, les instructions ont été préparées.',
    forgotPasswordDemoNotice: 'Vous pouvez utiliser directement le lien généré ci-dessous pour modifier votre mot de passe.',
    forgotPasswordDirectBtn: 'Définir un nouveau mot de passe',
    backToLogin: 'Retour à la connexion',
    resetPasswordTitle: 'Nouveau mot de passe',
    resetPasswordSubtitle: 'Choisissez un nouveau mot de passe pour votre compte.',
    resetPasswordBtn: 'Modifier le mot de passe',
    resetPasswordSuccess: 'Votre mot de passe a été modifié avec succès. Vous pouvez maintenant vous connecter.',
    resetPasswordMissingToken: 'Le jeton de réinitialisation est manquant ou invalide.',
    requestNewResetLink: 'Demander un nouveau lien',
  },
  home: {
    welcomeHello: 'Bonjour',
    welcomeReady: ' ! Prêt pour une nouvelle revue de code ?',
    taglineBadge: "Plateforme d'entraînement à la Code Review pour développeurs",
    heroTitle: 'Maîtrisez la revue de code.',
    heroTitleHighlight: ' Détectez ce que l’IA ne voit pas.',
    heroDesc:
      'On apprend activement à écrire du code, mais presque jamais à auditer celui des autres. Entraînez-vous sur des Pull Requests réalistes multi-langages, décelez les failles de sécurité OWASP et aiguisez votre esprit critique en équipe.',
    myDashboard: 'Tableau de bord de {name}',
    exploreDemo: 'Explorer la démo de code',
    createFreeAccount: 'Créer un compte gratuit',
    signIn: 'Se connecter',
    metricsAria: 'Chiffres clés',
    metricLanguages: 'Langages supportés',
    metricLevels: '5 Niveaux',
    metricLevelsSub: 'Du niveau 1 (syntaxe) au niveau 5 (expert)',
    metricPr: 'Façon GitHub Pull Request',
    demoPill: 'Expérience Interactive',
    demoTitle: 'L’anatomie d’une véritable revue de code',
    demoSubtitle:
      'Inspectez le contexte métier, parcourez le diff Git unifié, commentez la ligne suspecte et comparez votre analyse avec le verdict de notre juge IA.',
    demoTabsAria: 'Langages de démo',
    prOpen: 'PR Ouverte',
    modeAnomaly: 'Code soumis (Anomalie)',
    modeSolution: 'Solution attendue (Fix)',
    author: 'Auteur :',
    ticketContext: 'Contexte du ticket métier :',
    judgeApproved: 'Analyse validée par le juge d’évaluation',
    viewSolution: 'Voir le correctif idéal',
    languagesPill: 'Multi-langages & Couverture',
    languagesTitle: 'Formez votre regard sur les langages modernes',
    languagesSubtitle:
      'Chaque écosystème possède ses failles caractéristiques et ses erreurs de concurrence. Explorez des pièges authentiques inspirés des incidents de production réels.',
    targetedFlaws: 'Anomalies ciblées :',
    mysteryBadge: 'Nouveau • Mode Défi',
    mysteryTitle: 'Prêt pour l’audit à l’aveugle ? Testez le Mode Mystère',
    mysteryDesc:
      'Le langage, la difficulté et la thématique d’erreur sont masqués au départ. Vous devez lire le diff sans indice préalable, repérer l’anomalie et formuler votre critique en conditions réelles.',
    mysteryBtn: 'Défier le Mode Mystère',
    workflowPill: 'Méthodologie',
    workflowTitle: 'Comment progresser avec Code How?',
    workflowSubtitle:
      'Une boucle d’apprentissage conçue pour transformer la relecture de code en un réflexe d’ingénierie rigoureux et constructif.',
    step1Title: 'Sélection du Scénario',
    step1Desc:
      'Filtrez par langage de prédilection, par niveau de difficulté (de 1, une simple faute de syntaxe, à 5, des anomalies subtiles) ou activez le Mode Mystère aléatoire.',
    step2Title: 'Inspection du Diff Git',
    step2Desc:
      'Parcourez le contexte du ticket Jira et le diff de la Pull Request avec coloration syntaxique et repérage des modifications suspectes.',
    step3Title: 'Commentaire Inline',
    step3Desc:
      'Cliquez directement sur la ligne fautive pour formuler votre retour critique, expliquer la faille et proposer l’alternative recommandée.',
    step4Title: 'Évaluation IA & Score',
    step4Desc:
      'Recevez une note sur 100, analysez le débriefing détaillé du juge et découvrez la Ground Truth corrigée pour ancrer vos acquis.',
    progressionPill: 'Espace Personnel',
    progressionTitle: 'Votre tableau de bord personnel',
    progressionDesc:
      'Suivez votre courbe de progression temporelle, analysez vos scores par thématique (Sécurité OWASP, Performance, Architecture) et conservez un historique consultable de chaque scénario audité.',
    pFeature1: 'Courbe d’évolution des scores calculée en direct',
    pFeature2: 'Historique des Pull Requests et solutions conservé',
    pFeature3: 'Gestion du profil, pseudonyme et photo personnalisée',
    openDashboard: 'Ouvrir mon Tableau de Bord',
    createAccountSave: 'Créer un compte pour sauvegarder',
    chartTitle: 'Score de Progression • Code How?',
    chartAvg: 'Moyenne Globale',
    chartAudits: 'Audits Réalisés',
    chartConsistency: 'Régularité',
  },
  dashboard: {
    inProgressTitle: 'Challenges en cours',
    resume: 'Reprendre',
    chartDate: 'Date',
    chartScore: 'Note sur 100',
    workspaceAria: 'Espace de travail du tableau de bord',
    heroTitle: 'Votre espace personnel',
    heroTitleHighlight: 'de progression',
    heroDesc:
      "Analysez l'historique de vos revues, suivez l'évolution de vos scores et lancez de nouveaux challenges d'entraînement.",
    historyTitle: 'Historique',
    challengesCompleted: '{count} challenges terminés',
    newChallenge: 'Nouveau challenge',
    loadingHistory: "Chargement de l'historique…",
    historyError: "Impossible de charger l'historique.",
    emptyHistoryTitle: 'Aucune revue terminée',
    emptyHistorySub: "Lancez votre premier challenge pour commencer à bâtir votre historique d'audit.",
    challengeDetails: 'Détails du challenge',
    excellentAnalysis: 'Excellente analyse',
    goodAnalysis: 'Bonne analyse',
    needsWork: 'Analyse à perfectionner',
    evalScore: "Score d'évaluation",
    scoreHelp: 'Ce score reflète la précision de votre détection et la pertinence de vos remarques.',
    language: 'Langage :',
    level: 'Niveau :',
    category: 'Catégorie :',
    completedOn: 'Terminé le {date}',
    viewFullDebrief: 'Consulter le débriefing complet',
    launchAnother: 'Lancer un autre challenge',
    launcherIntro:
      'Sélectionnez vos critères pour générer un scénario sur-mesure ou tentez le mode Mystère pour un challenge surprise.',
    progressionTitle: 'Progression',
    filterPrefix: 'Filtre :',
    statScenarios: 'Scénarios',
    statAvg: 'Moyenne',
    statBest: 'Meilleur',
    statLast: 'Dernier',
    scoreEvolution: 'Évolution des scores',
    pointCount: '{count} point{s}',
    noScoreData: 'Aucune donnée de score',
    noScoreDataSub: 'Terminez un challenge pour visualiser votre courbe de progression.',
    auditorRank: "Rang d'auditeur",
    rankNovice: 'Novice',
    rankNoviceDesc: '{count} revue{s} réussie{s} restante{s} pour débloquer le rang d’Apprenti.',
    rankApprentice: 'Apprenti Reviewer',
    rankApprenticeDesc: '{count} revue{s} réussie{s} restante{s} pour passer Reviewer Confirmé.',
    rankConfirmed: 'Reviewer Confirmé',
    rankConfirmedDesc: '{count} revue{s} réussie{s} avant d’atteindre le rang d’Auditeur Senior.',
    rankSenior: 'Auditeur Senior 🏆',
    rankSeniorDesc: 'Expert de la revue de code avec {avg}% de score moyen.',
    rankRule: 'Seules les revues notées {min}/100 ou plus comptent.',
  },
  launcher: {
    language: 'Langage',
    difficulty: 'Difficulté',
    category: 'Type d’erreur',
    launch: 'Lancer le challenge',
    mystery: 'Mode Mystère',
    hint: 'Le mode Mystère tire au hasard le langage, la difficulté et le type d’erreur, sans vous les révéler.',
    preparing: 'Préparation de la pull request…',
    error: 'Impossible de créer le challenge.',
  },
  review: {
    draftsKept: 'Vos remarques non envoyées sont conservées : reprenez la partie depuis le tableau de bord.',
    title: 'Revue de code',
    loadingPr: 'Chargement de la pull request…',
    evaluating: 'Le juge évalue votre revue…',
    loadError: 'Impossible de charger le challenge.',
    submitError: 'La soumission a échoué. Réessayez.',
    remarkOnLine: 'Remarque sur la ligne {line}',
    textareaPlaceholder: 'Décrivez le problème, son impact et une piste de correction.',
    saveRemark: 'Enregistrer la remarque',
    yourRemarkLine: 'Votre remarque, ligne {line}',
    remarksSidebar: 'Vos remarques ({count})',
    sidebarHint:
      'Cliquez sur une ligne de code pour y écrire une remarque.',
    submitWithRemarks: 'Envoyer ma revue ({count})',
    approveWithoutRemarks: 'Approuver sans remarque',
    noRemarksYet: 'Aucune remarque pour l’instant. Cliquez sur une ligne suspecte dans le code.',
    approveWarningTitle: 'Approuver la PR telle quelle ?',
    approveWarning: 'Vous n’avez signalé aucun problème. Si la PR contient une anomalie, elle sera comptée comme manquée.',
    approveConfirm: 'Oui, approuver',
    keepReviewing: 'Continuer la revue',
    mission: 'Cette pull request cache au moins un problème. Trouvez-le et expliquez-le avant d’envoyer votre revue.',
    stepsAria: 'Étapes du jeu',
    step1: 'Lisez le ticket',
    step2: 'Cliquez sur la ligne suspecte',
    step3: 'Expliquez le problème',
    step4: 'Envoyez votre revue',
    help: 'Aide',
    helpClose: 'Fermer l’aide',
    helpTitle: 'Comment jouer ?',
    helpIntro: 'Vous êtes relecteur : un collègue vous demande de valider sa pull request (PR). Votre rôle est de repérer ce qui ne va pas avant que le code parte en production.',
    helpReadTitle: 'Lire un diff',
    helpRead: 'Les lignes en vert (+) sont ajoutées par le collègue, en rouge (−) supprimées, les autres sont inchangées et servent de contexte. Les problèmes se cachent dans les lignes ajoutées.',
    helpCommentTitle: 'Écrire une remarque',
    helpComment: 'Cliquez sur la ligne fautive (ou sur le bouton + à gauche). Une zone de texte s’ouvre sous la ligne : décrivez le problème, sa conséquence et une piste de correction, puis enregistrez. Vous pouvez en écrire plusieurs et les modifier.',
    helpScoreTitle: 'Comment c’est noté',
    helpScore: 'Chaque anomalie trouvée sur la bonne ligne rapporte des points, et une explication claire en rapporte davantage. Une remarque sur une ligne correcte compte comme faux positif et baisse un peu la note.',
    helpTipTitle: 'Astuce débutant',
    helpTip: 'Au niveau 1, cherchez une faute de syntaxe : point-virgule, deux-points, parenthèse ou guillemet manquant. Au niveau 2, un bug simple : mauvaise comparaison, boucle qui va un tour trop loin…',
    prOpen: 'PR ouverte',
    mysteryMode: 'Mode Mystère',
    ticketContext: 'Contexte du ticket métier :',
  },
  result: {
    meterAria: '{name} : {value} sur {max}',
    title: 'Débriefing',
    scoreOutOf100: 'Note : {score} sur 100',
    loading: 'Chargement du débriefing…',
    loadError: 'Impossible de charger le débriefing.',
    anomaliesFound: 'Anomalies trouvées ({found}/{total})',
    explanationQuality: 'Qualité des explications',
    precision: 'Précision ({count} faux positif{s})',
    judgeSummary: 'Synthèse du juge',
    heuristicNotice:
      'Le juge IA était indisponible : seules les lignes pointées ont été comparées.',
    expectedIssues: 'Anomalies attendues',
    statusFound: 'Trouvée',
    statusMissed: 'Manquée',
    statusFalsePositive: 'Faux positif',
    severity: 'Gravité :',
    yourRemarkAtLine: 'Votre remarque (ligne {line})',
    judgeFeedbackClarity: 'Avis du juge — clarté {score} / 100',
    expectedFix: 'Correctif attendu',
    offTargetRemarks: 'Remarques hors cible',
    newChallengeBtn: 'Nouveau challenge',
  },
  account: {
    title: 'Paramètres du Compte',
    avatar: 'Photo de profil',
    avatarHint: 'PNG ou JPG max 2 Mo',
    change: 'Changer',
    deletePhoto: 'Supprimer la photo',
    delete: 'Supprimer',
    themeLabel: "Thème de l'interface",
    themeDark: 'Sombre',
    themeLight: 'Clair',
    langLabel: "Langue de l'interface",
    langFr: 'Français',
    langEn: 'English',
    email: 'Email',
    pseudo: 'Pseudo',
    newPseudo: 'Nouveau pseudo',
    password: 'Mot de passe',
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    nameEmpty: 'Le pseudo ne peut pas être vide.',
    fillAllFields: 'Veuillez remplir tous les champs.',
    passwordsMismatch: 'Les nouveaux mots de passe ne correspondent pas.',
    fileTooLarge: "L'image ne doit pas dépasser 2 Mo.",
    avatarUpdateError: 'Erreur lors de la mise à jour de la photo.',
    avatarRemoveError: 'Erreur lors de la suppression.',
    deleteAccount: 'Supprimer mon compte',
    deleteAccountHint: 'Efface définitivement votre compte et tout votre historique de revues.',
    deleteAccountConfirm: 'Cette action est irréversible. Saisissez votre mot de passe pour confirmer.',
    deleteAccountFinal: 'Supprimer définitivement',
  },
  diff: {
    added: 'Ligne ajoutée',
    deleted: 'Ligne supprimée',
    unchanged: 'Ligne inchangée',
    hunk: 'Bloc',
    commentAria: 'Commenter la ligne {line} de {file}',
    commentTitle: 'Écrire une remarque sur cette ligne',
  },
  notFound: {
    title: 'Page introuvable',
    desc: "Cette adresse ne correspond à aucune page de l'application.",
    returnHome: "Revenir à l'accueil",
  },
  protected: {
    invalidSession: 'Session invalide',
    incompleteDesc:
      'Votre session est reconnue mais incomplète. Déconnectez-vous puis reconnectez-vous.',
    logout: 'Se déconnecter',
  },
  theme: {
    switchToLight: 'Passer en thème clair',
    switchToDark: 'Passer en thème sombre',
  },
}

export type Translations = typeof fr
